import { RiskAnalyticsBuilder } from './../builders/risk-analytics.builder';
import { RiskAnalytics } from './../models/risk-analytics';

export class RiskAnalyticsDirector {
	public construct(portfolioJson: any): RiskAnalytics {
		if (portfolioJson.returns) {
			portfolioJson.returns.weightedAveragePerformance = portfolioJson.returns.weightedAveragePerformance || {};
			portfolioJson.returns.latestPerf = portfolioJson.returns.latestPerf || {};

			return new RiskAnalyticsBuilder()
				.setUpsideCapture(portfolioJson.returns.weightedAveragePerformance.rnrCaptureRatioUpY1)
				.setDownsideCapture(portfolioJson.returns.weightedAveragePerformance.rnrCaptureRatioDownY1)
				.setSharpeRatio(portfolioJson.returns.latestPerf.oneYearSharpeRatio)
				.setSharpeRatio3Yr(portfolioJson.returns.latestPerf.threeYearSharpeRatio)
				.setSharpeRatio5Yr(portfolioJson.returns.latestPerf.fiveYearSharpeRatio)
				.setStandardDeviation1Yr(portfolioJson.returns.latestPerf.oneYearRiskAnnualized)
				.setStandardDeviation3Yr(portfolioJson.returns.latestPerf.threeYearRiskAnnualized)
				.setStandardDeviation5Yr(portfolioJson.returns.latestPerf.fiveYearRiskAnnualized)
				.setRiskContributionMap(portfolioJson)
				.setRiskAsOfDateMap(portfolioJson)
				.build();
		}
	}
}
